import { render, staticRenderFns } from "./PointCreditTelecomCancel.vue?vue&type=template&id=13efd41c"
import script from "./PointCreditTelecomCancel.vue?vue&type=script&lang=js"
export * from "./PointCreditTelecomCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports